/** @flow */
import { startRequest, finishRequest } from "@store/utils";
import {
  GetReportingFocusListsManagerReport,
  GetReportingFocusListsManagerReportSuccess,
  GetReportingFocusListsManagerReportError,
  ExportFocusListsManagerReport,
  ExportFocusListsManagerReportSuccess,
  SetFocusListsManagerReportViewState,
} from "@modules/reporting/constants/actions";
import type { ReportState, ManagerReportViewState } from "./types";
import { cloneObject } from "@utils/object";

export const initialViewState: ManagerReportViewState = {
  managerFocusListExpanded: true,
  managerResultsExpanded: true,
};

export const initialState = {
  requestsInProgress: 0,
  reportGenerateInProgress: 0,
  error: null,
  details: null,
  reportData: null,
  charts: {
    focusList: null,
  },
  viewState: initialViewState,
};

export const onGetReportingFocusListsManagerReport = (state: ReportState) => () =>
  startRequest(state);

export const onGetReportingFocusListsManagerReportSuccess = (state: ReportState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    ...payload,
    charts: {
      ...state.charts,
      focusList: payload.focusList,
    },
  };
};

const onGetReportingFocusListsManagerReportError = (state: ReportState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

const onExportFocusListsManagerReport = (state: ReportState) => () => {
  return {
    ...state,
    reportGenerateInProgress: ++state.reportGenerateInProgress,
  };
};

const onExportFocusListsManagerReportSuccess = (state: ReportState) => () => {
  return {
    ...state,
    reportGenerateInProgress:
      state.reportGenerateInProgress > 0 ? --state.reportGenerateInProgress : 0,
  };
};

export const onSetViewState = (state: ReportState) => ({ payload }: Object) => {
  return {
    ...state,
    viewState: {
      ...state.viewState,
      ...payload,
    },
  };
};

export default (state: ReportState = initialState, action: Object): ReportState => {
  const act = {
    [ExportFocusListsManagerReport]: onExportFocusListsManagerReport,
    [ExportFocusListsManagerReportSuccess]: onExportFocusListsManagerReportSuccess,
    [GetReportingFocusListsManagerReport]: onGetReportingFocusListsManagerReport,
    [GetReportingFocusListsManagerReportSuccess]: onGetReportingFocusListsManagerReportSuccess,
    [GetReportingFocusListsManagerReportError]: onGetReportingFocusListsManagerReportError,
    [SetFocusListsManagerReportViewState]: onSetViewState,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
